import { render, staticRenderFns } from "./replaceRecord.vue?vue&type=template&id=1cc638cc&scoped=true&"
import script from "./replaceRecord.vue?vue&type=script&lang=js&"
export * from "./replaceRecord.vue?vue&type=script&lang=js&"
import style0 from "./replaceRecord.vue?vue&type=style&index=0&id=1cc638cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc638cc",
  null
  
)

export default component.exports